!function () {
  const INIT_ATTR = 'data-catalog-mega-initialized';
  const SELECTED_CLASS = 'is-selected';

  function setSelected(buttons, active) {
    buttons.forEach(btn => {
      btn.classList.toggle(SELECTED_CLASS, btn === active);
    });
  }

  function initMega(el) {
    if (!el || el.hasAttribute(INIT_ATTR)) return;
    el.setAttribute(INIT_ATTR, 'true');

    const l1Buttons = Array.from(el.querySelectorAll('[data-l1]'));
    const l2Buttons = Array.from(el.querySelectorAll('[data-l2]'));
    const l2Col = el.querySelector('[data-l2-col]');
    const l3Col = el.querySelector('[data-l3-col]');

    function setAriaExpanded(buttons, active) {
      buttons.forEach(btn => btn.setAttribute('aria-expanded', btn === active ? 'true' : 'false'));
    }

    function hideL2AndFeaturedPanels() {
      el.querySelectorAll('[data-panel^="l2-"]').forEach(p => p.hidden = true);
      el.querySelectorAll('[data-panel^="l1f-"]').forEach(p => p.hidden = true);
    }

    function showL1Panel(key) {
      el.querySelectorAll('[data-panel^="l1-"]').forEach(p => p.hidden = true);
      const panel = el.querySelector(`[data-panel="${CSS.escape(key)}"]`);
      if (panel) panel.hidden = false;
    }

    function showFeaturedPanel(index) {
      const key = `l1f-${index}`;
      const panel = el.querySelector(`[data-panel="${CSS.escape(key)}"]`);
      if (panel) {
        hideL2AndFeaturedPanels();
        panel.hidden = false;
        if (l3Col) l3Col.hidden = false;
      } else {
        if (l3Col) l3Col.hidden = true;
      }
    }

    function onL1Click(btn) {
      const key = btn.getAttribute('data-target');
      const index = (key || '').replace('l1-', '');

      // Expand l2 col
      if (l2Col) l2Col.hidden = false;

      // aria + selected state on all L1 buttons
      setAriaExpanded(l1Buttons, btn);
      setSelected(l1Buttons, btn);

      // Show the correct L2 panel
      showL1Panel(key);

      // Reset L2 selected/aria states within the newly shown panel
      const l1Panel = el.querySelector(`[data-panel="${CSS.escape(key)}"]`);
      if (l1Panel) {
        const panelL2Buttons = Array.from(l1Panel.querySelectorAll('[data-l2]'));
        setAriaExpanded(panelL2Buttons, null);
        setSelected(panelL2Buttons, null);
      }

      // Show featured product panel in col 3
      showFeaturedPanel(index);
    }

    function onL2Click(btn) {
      const key = btn.getAttribute('data-target');
      const parentPanel = btn.closest('[data-panel^="l1-"]');
      const panelL2Buttons = Array.from(
        parentPanel ? parentPanel.querySelectorAll('[data-l2]') : l2Buttons
      );

      // aria + selected state on L2 buttons within this panel only
      setAriaExpanded(panelL2Buttons, btn);
      setSelected(panelL2Buttons, btn);

      // Show L3 panel in col 3 (hides featured panel)
      hideL2AndFeaturedPanels();
      const l3Panel = el.querySelector(`[data-panel="${CSS.escape(key)}"]`);
      if (l3Panel) {
        l3Panel.hidden = false;
        if (l3Col) l3Col.hidden = false;
      } else {
        if (l3Col) l3Col.hidden = true;
      }
    }

    // Attach events
    l1Buttons.forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); onL1Click(btn); });
    });
    l2Buttons.forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); onL2Click(btn); });
    });

    // Initial state — everything hidden
    el.querySelectorAll('[data-panel^="l1-"]').forEach(p => p.hidden = true);
    if (l2Col) l2Col.hidden = true;
    hideL2AndFeaturedPanels();
    if (l3Col) l3Col.hidden = true;
    setAriaExpanded(l1Buttons, null);
    setSelected(l1Buttons, null);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-catalog-mega]').forEach(initMega);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:reorder', e => initAll(e.target));
  document.addEventListener('shopify:section:select', e => initAll(e.target));
}();